function openUpsell(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName('upsell-tab-content');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }
  tablinks = document.getElementsByClassName('upsell-tab-link');
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
  }
  var tab = document.getElementById(tabName);
  if (tab) tab.style.display = 'block';
  if (evt && evt.currentTarget) evt.currentTarget.classList.add('active');
}

document.addEventListener('submit', function (e) {
  if (!e.target.classList.contains('upsell-add-form')) return;
  e.preventDefault();

  const form = e.target;
  const btn = form.querySelector('.upsell-btn-plus');
  const formData = new FormData(form);
  const originalSVG = btn ? btn.innerHTML : null;
  const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(routes + 'cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      if (btn) {
        btn.innerHTML =
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        btn.style.background = '#000';
        btn.style.color = '#fff';
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      }
      setTimeout(function () {
        if (btn && originalSVG !== null) {
          btn.innerHTML = originalSVG;
          btn.style.background = '#fff';
          btn.style.color = '#000';
        }
      }, 2000);
    })
    .catch(function (error) {
      console.error('Error:', error);
    });
});
